/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
  // Set to true only when debugging i18n missing keys; avoids console spam in development
  debug: false,
  i18n: {
    defaultLocale: 'pt',
    // Mesmos idiomas do app (sweep/l10n.yaml + locale_provider.dart).
    locales: ['pt', 'en', 'es', 'fr', 'de', 'it', 'ja', 'ko', 'ar', 'he', 'zh'],
    // Entrada na raiz redireciona para o idioma da máquina (Accept-Language),
    // respeitando o cookie NEXT_LOCALE gravado quando a pessoa troca à mão.
    localeDetection: true,
  },
  fallbackLng: 'pt',
  returnNull: false,
  nonExplicitSupportedLngs: true,
  localePath:
    typeof window === 'undefined'
      ? // eslint-disable-next-line @typescript-eslint/no-require-imports
        require('path').resolve('./public/locales')
      : '/locales',

  reloadOnPrerender: process.env.NODE_ENV === 'development',

  /**
   * @link https://github.com/i18next/next-i18next#6-advanced-configuration
   */
}
